import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { FilterPicker } from 'seagull';
import { filterTemplates } from './AddServices/AddServices.utils';
import { AddServicesSearchbox } from './AddServices/AddServicesSearchbox';
import { AddServicesServiceList } from './AddServices/AddServicesServiceList';
export { AddServicesTestIds as AddServicesFilterPickerTestIds } from './AddServices/AddServicesTestIds';
const AddServicesFilterPicker = (param)=>{
    let { serviceTemplates, selectedServiceTemplateIds, hasError, testId, onApply, onClose, onToggle } = param;
    const [searchTerm, setSearchTerm] = useState('');
    const filteredTemplates = useMemo(()=>filterTemplates(serviceTemplates, searchTerm), [
        serviceTemplates,
        searchTerm
    ]);
    return /*#__PURE__*/ _jsx(FilterPicker, {
        testId: testId,
        title: "Add services",
        label: "+ Add services",
        buttonTitle: "+ Add services",
        highlightTrigger: false,
        onApply: ()=>onApply(selectedServiceTemplateIds),
        onClose: (options)=>{
            onClose(options);
            setTimeout(()=>setSearchTerm(''), 100);
        },
        headerContent: /*#__PURE__*/ _jsx(AddServicesSearchbox, {
            searchTerm: searchTerm,
            onSearchChange: setSearchTerm,
            onSearchClear: ()=>setSearchTerm('')
        }),
        popoverWidth: 400,
        type: "textButton",
        hasError: hasError,
        children: /*#__PURE__*/ _jsx(AddServicesServiceList, {
            serviceTemplates: filteredTemplates,
            selectedServiceTemplateIds: selectedServiceTemplateIds,
            onToggle: onToggle
        })
    });
};
export default AddServicesFilterPicker;
